<div class="calendar-picker">
  <button
    type="button"
    class="calendar-picker__trigger"
    (click)="toggle()"
    [attr.aria-expanded]="isOpen"
    aria-haspopup="dialog"
    [attr.aria-controls]="panelId"
  >
    <span>{{ buttonLabel }}</span>
    <span
      class="calendar-picker__chevron"
      [class.calendar-picker__chevron--open]="isOpen"
      aria-hidden="true"
    ></span>
  </button>

  <button
    *ngIf="isOpen"
    type="button"
    class="calendar-picker__backdrop"
    aria-label="Close calendar menu"
    (click)="close()"
  ></button>

  <section
    *ngIf="isOpen"
    [id]="panelId"
    class="calendar-picker__panel"
    role="dialog"
    aria-label="Add event to calendar"
  >
    <div class="calendar-picker__header">
      <h3>Add to calendar</h3>
    </div>
    <p *ngIf="isLoading" class="calendar-picker__status" role="status">
      Preparing calendar options…
    </p>
    <p *ngIf="error" class="calendar-picker__error" role="alert">{{ error }}</p>
    <div *ngIf="options && !isLoading" class="calendar-picker__actions">
      <a
        class="calendar-picker__option"
        [href]="options.googleCalendarUrl"
        target="_blank"
        rel="noopener noreferrer"
        (click)="deferClose()"
      >
        <span class="calendar-picker__option-label">Google Calendar</span>
      </a>
      <button
        type="button"
        class="calendar-picker__option"
        (click)="downloadCalendar()"
        [disabled]="isDownloading"
      >
        <span class="calendar-picker__option-label"
          >Apple Calendar, Outlook &amp; more</span
        >
        <span class="calendar-picker__option-meta"
          >Download and open the calendar file.</span
        >
      </button>
    </div>
  </section>
</div>
